// Promoted events (Showcase, Networking) are always sponsored. Other values or Settings can be added later.
const isPromoted = (content) => {
  return (
    content.fieldEventType?.name === "Showcase" ||
    content.fieldEventType?.name === "Networking"
  );
};

export { isPromoted };
